import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EditSubscriptionModel = types
  .model("EditSubscriptionModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("EDITING_SUBSCRIPTION_DATA");
    },
    set(response) {
      let status = response.status;
      let data;
      if (status === 204) {
        data = `The subscription has been edited successfully.`;
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res:"Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default EditSubscriptionModel;
